import { MessageSquare } from 'lucide-react';

const footerLinks = {
  features: [
    { name: 'Application Forms', href: '/features/custom-application-forms' },
    { name: 'Applicant Tracking', href: '/features/applicant-tracking' },
    { name: 'Calendar Integration', href: '/features/google-calendar-integration' },
    { name: 'All Features', href: '/features' },
  ],
  industries: [
    { name: 'Restaurants', href: '/industries/restaurants-hospitality' },
    { name: 'Healthcare', href: '/industries/healthcare-medical' },
    { name: 'Construction', href: '/industries/construction-trades' },
    { name: 'All Industries', href: '/industries' },
  ],
  locations: [
    { name: 'Florida', href: '/locations/florida' },
    { name: 'California', href: '/locations/california' },
    { name: 'Texas', href: '/locations/texas' },
    { name: 'New York', href: '/locations/new-york' },
  ],
  company: [
    { name: 'About', href: '/#features' },
    { name: 'Contact', href: '/contact' },
    { name: 'All Locations', href: '/locations' },
  ],
  resources: [
    { name: 'Blog', href: '/blog' },
    { name: 'Help Center', href: '/contact' },
    { name: 'Get Started', href: 'https://app.ihirefast.com' },
    { name: 'Sign In', href: 'https://app.ihirefast.com' },
  ],
  legal: [
    { name: 'Privacy', href: '/privacy' },
    { name: 'Terms', href: '/terms' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-custom py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-8 lg:gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <a href="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <MessageSquare className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-white">
                i<span className="text-primary-500">Hire</span>Fast
              </span>
            </a>
            <p className="text-sm text-gray-400 max-w-xs">
              Automate your recruitment with applicant tracking and scheduling.
              Hire faster, work less.
            </p>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-white font-semibold mb-4 capitalize">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <a href={link.href} className="text-sm hover:text-white transition-colors">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} iHireFast. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://app.ihirefast.com" className="text-sm text-gray-400 hover:text-white transition-colors">
              Sign In
            </a>
            <a
              href="https://app.ihirefast.com"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors"
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
